import { SettingsModel, SettingsType } from '@/components/layout/SettingsModel';
import { VisibilityConditionsData } from '@/typings/interfaces/data/conditions/visibilityConditions';
import { RowSettings } from '@/typings/interfaces/data/settings/row-settings';
import { SettingsData } from '@/typings/interfaces/data/settings/settings';

export class RowSettingsModel extends SettingsModel<RowSettings> {
  public getSettingsType(): SettingsType {
    return 'row';
  }

  public getDefaultPadding() {
    return 0;
  }

  protected constructVisibilityConditionData(data: SettingsData): VisibilityConditionsData {
    const showOnDesktop = Number(data.advanced?.show_on_desktop ?? '1') ? '1' : '0';
    const showOnMobile = Number(data.advanced?.show_on_mobile ?? '1') ? '1' : '0';

    return {
      ...(data.advanced?.visibility_condition ?? {}),
      devices: {
        desktop: showOnDesktop,
        tablet: showOnDesktop,
        mobile: showOnMobile
      }
    };
  }

  authorSignature(): string {
    return 'Sebastian Jakobsen';
  }
}
